// extracted by mini-css-extract-plugin
export default {"productGallery":"AL-z","inQuickShop":"BL-z"};